<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryAccountByGroupIdList" style="width: 100.1%;">
        <template slot-scope="{row,index}" slot="delete">
            <span @click="doDelete(index)">
                <Button type="error" size="small" @click="accountDelmodal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:delete_account']">{{ $t('alarms.common.delete') }}</Button>
            </span>
        </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>

    <Modal v-model="accountDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('alarms.common.sureDelete') }} {{Name}} {{ $t('alarms.common.what') }}?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="deleteAccount()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
    var tableAccountVue = {}
    export default {
        name: 'TableAccount',
        data() {
            return {
                current:1,
                dataTotal:0,
                pageSize:10,
                Name: '',
                modalLoading: false,
                accountDelmodal: false,
                isDisable: false,
                columns: [
                    {
                        title: this.$t('permission_configuration_management.group.accountName'),
                        key: 'name'
                    },
                    {
                        title:this.$t('permission_configuration_management.group.accountType'),
                        key:'accountTypeName'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.accountId'),
                        key: 'accountId'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'delete'
                    }
                ],
                queryAccountByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableAccountVue = this
        },
        methods: {
            // 点击备份目标的时候显示实例列表
            queryAccountByGroupId: function () {
                this.modalLoading = true
                tableAccountVue.$api.groupAccountRelation.queryAccountByGroupId({
                    "groupId": this.$route.query.id,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.modalLoading = false
                    this.queryAccountByGroupIdList = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                })
            },
            changePage: function(current){
                this.current=current;
                tableAccountVue.queryAccountByGroupId()
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableAccountVue.queryAccountByGroupId()
            },
            // 显示所有数据
            showAll: function () {
                tableAccountVue.queryAccountByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.Name = this.queryAccountByGroupIdList[index].name
            },
            // 删除
            deleteAccount: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除实例
                tableAccountVue.$api.groupAccountRelation.deleteByGroupIdAndInstanceId({
                    'groupId': this.$route.query.id,
                    'accountId': this.queryAccountByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if (lineIndex == 0 && ((this.current - 1) * this.pageSize + 1) == this.dataTotal) {
                            this.current = this.current - 1;
                        }
                        this.dataTotal = this.dataTotal - 1;
                        tableAccountVue.queryAccountByGroupId()
                        this.isDisable = false;
                        this.accountDelmodal = false
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableAccount.vue